export const iconFontAwesomeShoppingBasketShopping = (
	<i className="fa-solid fa-basket-shopping"></i>
);
